import React from 'react';
import map from '../img/map.png'

export default function GoogleMaps() {
    return <img src={map} style={{width: "100%", height: "100%", objectFit: 'cover'}} alt='Map'/>
}